import quoteGQLString from '../util/quoteGQLString';

export default (orgId) => `
    approveOrg (org: ${quoteGQLString(orgId)}) {
        id
    }
`;
